import { useState } from 'react';
import mapIcon from '../../../common/images/revamp/icon/map.svg';
import CustomGoogleMap from '../../GoogleMaps';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useMemo } from 'react';

const Map = () => {
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	const googleMapProps = useMemo(() => {
		return {
			onClose: handleCloseBottomSheet,
			isFormAddress: false,
		};
	}, []);

	return (
		<>
			<div onClick={handleClick} className='flex gap-1.5 items-center border-1 border-solid border-gray-300 rounded-full py-2 px-3 bg-gray-50'>
				<img src={mapIcon} alt='map' className='w-4 h-4' />
				<div className='text-blue-400 text-xs'>Pilih lewat map</div>
			</div>
			<BottomSheet key={'select-location-on-map'} header={null} className='z-10' open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				<CustomGoogleMap {...googleMapProps} />
			</BottomSheet>
		</>
	);
};

export default Map;
